import React from 'react';

const HomeTabIcon = ({
  className = '',
  state = 'not-selected', // 'not-selected', 'hover', 'selected'
  config, // Add config prop for dynamic styling
  ...props
}) => {
  const getStrokeColor = () => {
    // Use dynamic color from config if available, otherwise fallback to CSS classes
    if (config?.element_color) {
      switch (state) {
        case 'selected':
        case 'hover':
          return config.element_color;
        case 'not-selected':
        default:
          return `${config.element_color}80`; // 50% opacity for inactive state
      }
    }

    // Fallback to CSS classes when no config is provided
    switch (state) {
      case 'selected':
        return 'text-v3-black-heading';
      case 'hover':
        return 'text-v3-black-heading';
      case 'not-selected':
      default:
        return 'text-v3-black-secondary';
    }
  };

  const getIconSize = () => {
    return state === 'selected' ? { width: 25, height: 24 } : { width: 23, height: 22 };
  };

  const { width, height } = getIconSize();
  const strokeColor = getStrokeColor();

  if (state === 'selected') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 25 24"
        fill="none"
        className={config?.element_color ? className : `${strokeColor} ${className}`}
        style={config?.element_color ? { color: strokeColor } : undefined}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.02 7.823C2.5 8.77 2.5 9.915 2.5 12.203V13.725C2.5 17.625 2.5 19.576 3.672 20.788C4.844 22 6.729 22 10.5 22H14.5C18.271 22 20.157 22 21.328 20.788C22.499 19.576 22.5 17.626 22.5 13.725V12.204C22.5 9.915 22.5 8.771 21.98 7.823C21.462 6.874 20.513 6.286 18.616 5.108L16.616 3.867C14.611 2.622 13.608 2 12.5 2C11.392 2 10.39 2.622 8.384 3.867L6.384 5.108C4.487 6.286 3.539 6.874 3.02 7.823ZM9.946 15.398C9.86715 15.3366 9.77682 15.2916 9.68034 15.2657C9.58386 15.2397 9.48316 15.2333 9.38416 15.2468C9.28515 15.2603 9.18984 15.2934 9.10382 15.3442C9.01781 15.3951 8.94281 15.4626 8.88324 15.5428C8.82368 15.623 8.78074 15.7143 8.75696 15.8114C8.73317 15.9084 8.72902 16.0092 8.74474 16.1079C8.76046 16.2066 8.79574 16.3011 8.8485 16.386C8.90127 16.4708 8.97045 16.5443 9.052 16.602C10.0477 17.3461 11.257 17.7487 12.5 17.75C13.7426 17.7485 14.9516 17.3459 15.947 16.602C16.0285 16.5443 16.0977 16.4708 16.1505 16.386C16.2033 16.3011 16.2385 16.2066 16.2543 16.1079C16.27 16.0092 16.2658 15.9084 16.242 15.8114C16.2183 15.7143 16.1753 15.623 16.1158 15.5428C16.0562 15.4626 15.9812 15.3951 15.8952 15.3442C15.8092 15.2934 15.7138 15.2603 15.6148 15.2468C15.5158 15.2333 15.4151 15.2397 15.3187 15.2657C15.2222 15.2916 15.1319 15.3366 15.053 15.398C14.3161 15.9498 13.4206 16.2486 12.5 16.25C11.5794 16.2486 10.6829 15.9498 9.946 15.398Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 23 22"
      fill="none"
      className={config?.element_color ? className : `${strokeColor} ${className}`}
      style={config?.element_color ? { color: strokeColor } : undefined}
      {...props}
    >
      <path
        d="M1.86404 11.958C1.48404 9.321 1.29404 8.002 1.83504 6.875C2.37604 5.748 3.52604 5.062 5.82704 3.692L7.21204 2.867C9.30004 1.622 10.346 1 11.5 1C12.654 1 13.699 1.622 15.788 2.867L17.173 3.692C19.473 5.062 20.624 5.748 21.165 6.875C21.706 8.002 21.515 9.321 21.135 11.958L20.857 13.895C20.37 17.283 20.126 18.976 18.951 19.988C17.776 21 16.053 21 12.606 21H10.394C6.94704 21 5.22404 21 4.04904 19.988C2.87404 18.976 2.63004 17.283 2.14304 13.895L1.86404 11.958Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M8.5 15C9.35 15.63 10.385 16 11.5 16C12.615 16 13.65 15.63 14.5 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default HomeTabIcon;
